//      
import { getRect,                         } from 'css-box-model';

export default (frame         , subject         )        => {
  const result       = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left),
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/droppable/util/clip.js